import { Outlet } from "@tanstack/react-router";
import { ViewServices } from "./view-service";
import { ViewHotels } from "./view-hotels";

export function FulfillmentsView({ id }: { id: string }) {
  return (
    <div className="grid gap-4">
      <ViewHotels id={id} />
      <ViewServices id={id} />
      <Outlet />
    </div>
  );
}
